import { DashboardLayout } from "@/app/layout/DashboardLayout";
import { useEffect } from "react";
import useGcpsUIController from "@/hooks/useGlobalContext";
import { Link } from "react-router-dom";
import pageRoutes from "@/app/routes/route";
import { Card, CardAction, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const DashboardPage = () => {
	const { setPageTitle, controller } = useGcpsUIController();
	const { resident } = controller;

	useEffect(() => {
		setPageTitle("Dashboard");

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<DashboardLayout>
			<div className="space-y-6">
				{(() => {
					const hour = new Date().getHours();
					const greeting = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
					const firstName = resident?.first_name || "Guest";
					return <h1 className="text-2xl font-bold capitalize">{greeting}, {firstName}</h1>;
				})()}

				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
					{pageRoutes.filter(item => (item.type !== "index" && item.type !== "dashboard") && !!item.path).map((route) => {
						return (
							<Link to={route.path as string} key={route.path}>
								<Card className="shadow-none flex-col:unset bg-gray-100/30 hover:bg-gray-100 dark:bg-gray-400/10 dark:hover:bg-gray-400/30">
									<CardHeader className="has-data-[slot=card-action]:grid-cols-[auto_1fr]">
										<CardAction className="col-start-1 mr-3">
											{route.icon && <route.icon size={50} />}
										</CardAction>
										<CardTitle className="mb-3">{route.name}</CardTitle>
										<CardDescription>
											{route.description}
										</CardDescription>
									</CardHeader>
								</Card>
							</Link>
						);
					})}
				</div>
			</div>
		</DashboardLayout>
	);
};